import * as React from 'react'
import { TabItemProps } from './TabItem'
import { TabItem } from './TabItem'

export type TabsProps = {
  tabs: Array<TabItemProps>
  onSelected?: (item: TabItemProps) => void
  children?: React.ReactNode
}

export const Tabs: React.FC<TabsProps> = ({ tabs, onSelected, children }) => {
  return (
    <div className="tw-flex tw-h-full tw-flex-col">
      {/* Tab Header - Sticky with gradient background */}
      <div className="tw-sticky tw-top-0 tw-z-20 tw-max-h-[54px] tw-border-b tw-border-base-300 tw-bg-[linear-gradient(180deg,_#FFFFFF_0%,_#FAFBFF_100%)] tw-px-1">
        <nav className="tw-flex tw-w-full tw-items-end tw-overflow-x-auto">
          {tabs.map((tab) => (
            <TabItem
              key={tab.name}
              name={tab.name}
              active={tab.active}
              disabled={tab.disabled}
              invalid={tab.invalid}
              stickers={tab.stickers}
              type={tab.type}
              icon={tab.icon}
              onSelected={(selectedTab) => {
                if (onSelected) {
                  onSelected(selectedTab)
                }
              }}
            />
          ))}
        </nav>
      </div>
      
      {/* Tab Content */}
      {children}
    </div>
  )
}

